const workflowState = {
  // common
  modalState: false,
  renameModal: false,
  moveModal: false,
  authModal: false,
  modalInput : [],
  modalData: [],
  category: [
    // {
    //   name: "대시보드",
    //   url: "/user/dashboard",
    // },
    {
      name: "목록",
      url: "/user/workflows",
    },
    {
      name: "기록",
      url: "/user/history",
    },
    {
      name: "템플릿",
      url: "/user/template",
    },
  ],
  nowWorkName: "워크플로우 실행 기록",
  nowWorkCode: "",
  nowGroupCode: "",
  xApiKey: "X-API-KEY",

  // group
  groups: [],
  groupCode: "",
  groupName: "",

  // workflow
  appName: "",
  workflowCode: "",
  workflow: {},
  workflowName: "워크플로우",
  appCode: "",
  apiCode: "",
  account: "",
  apiSchema: [],
  apis: [],
  triggers: [],
  actions: [],
  apps: [],
  selectApps: [],
  app: [],
  api: [],
  works: [],
  workflows: [],
  appNames: [],
  sourceTriggerSchemas: [],
  workflowDetailHistory: {},
  workflowDetailHistorys: [],
  apiHistorys: [],
  connections: [],

  workflowsS: [],
  authenticationS: {},
  apiS: {
    appCode: "",
    apiName: "",
    apiCode: "",
    versionCode: "",
    apiKey: "",
    apiType: "",
    design: {
      authType: "",
      forms: [],
    },
    configure: {},
    test: {
      request: {
        athentication: {},
        params: []
      },
      response: {
        source: ""
      }
    },
    define: {
      source: "",
      mapping: []
    },
  },
  configureS: {
    // type: "",
    // connect: "",
    // url: "",
    // method: "",
    // header: {},
    // uRLParam: {},
    // requestBody: {},
    // autoEmptyParam: {},
    // autoBlankParamDelete: {},
  },
  testS: {
    request: {
      athentication: {},
      params: [],
    },
    response: {},
  },
  defineS: {
    source: "",
    mapping: [],
  },
  formsS: {
    index: "",
    label: "",
    formKey: "",
    required: "",
    dropdown: "",
    dropdownSource: {},
    type: "",
    description: "",
    value: "",
  },
};

export default workflowState;
